export const V2_HEADING = "v2: Heading";
export const V2_TEXT = "v2: Text";
export const FUNNEL_BACK_BUTTON = "Back Button";
export const FUNNEL_NEXT_BUTTON_WITH_DISABLED = "Next Button With Disabled";
export const FUNNEL_CHOICE_BOX = "Choice Box";
export const FUNNEL_CHOICE_BOX_ITEM = "Choice Box Item";
export const LP_FUNNEL_STEP_FORM = "LP Funnel Step Form";
export const LIMITED_SCOPE_DRAWER_TRIGGER = "Limited Scope Drawer Trigger";
export const LIMITED_SCOPE_DIALOG_TRIGGER = "Limited Scope Dialog Trigger";
